import React, { useCallback } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../../../stores/auth';

interface SignInFormInputs {
    email: string;
    password: string;
}

const signInSchema = yup.object().shape({
    email: yup.string().email('Email không hợp lệ').required('Email là bắt buộc'),
    password: yup.string().min(6, 'Mật khẩu phải có ít nhất 6 ký tự').required('Mật khẩu là bắt buộc'),
});

interface SignInFormProps {
}

const SignInForm: React.FC<SignInFormProps> = React.memo(() => {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<SignInFormInputs>({
        resolver: yupResolver(signInSchema),
    });

    const { loading, signIn } = useAuthStore();

    const onSubmit: SubmitHandler<SignInFormInputs> = useCallback(async (data) => {
        await signIn(data.email, data.password);
    }, [signIn]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 w-full">
            <div>
                <label htmlFor="signin-email" className="block text-sm font-medium text-gray-700">
                    Email
                </label>
                <Input
                    id="signin-email"
                    type="email"
                    placeholder="you@example.com"
                    {...register('email')}
                    className="mt-1"
                />
                {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
            </div>
            <div>
                <label htmlFor="signin-password" className="block text-sm font-medium text-gray-700">
                    Mật khẩu
                </label>
                <Input
                    id="signin-password"
                    type="password"
                    placeholder="Mật khẩu của bạn"
                    {...register('password')}
                    className="mt-1"
                />
                {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
            </div>
            <Button type="submit" disabled={isSubmitting} className="w-full text-blue-500">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Đăng nhập'}
            </Button>
        </form>
    );
});

export default SignInForm;